import {Anchor} from 'src/design/atoms/Anchor';
import {Group} from 'src/design/atoms/Group';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import {Link} from 'react-router-dom';
import type {ProjectAccessPermissionResponse} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export interface ProjectAccessPermissionsProps {
  permissions?: ProjectAccessPermissionResponse[];
}

export const ProjectAccessPermissions: React.FC<ProjectAccessPermissionsProps> = ({
  permissions,
}) => {
  if (!permissions || permissions.length === 0) {
    return (
      <Text size="sm" c="dimmed">
        No project assignments. This user can see data from all projects.
      </Text>
    );
  }

  return (
    <>
      {permissions.map((permission, index) => (
        <Group key={index} mt="xs" gap="xs" wrap="nowrap" align="baseline">
          <Text size="sm" fw={500}>
            {permission.project.name}
          </Text>
          {permission.rules.length === 0 ? (
            <Text size="sm" c="dimmed">
              —
            </Text>
          ) : (
            <Group gap="xs">
              {permission.rules.map(rule => (
                <Anchor
                  key={rule.ruleId}
                  component={Link}
                  to={PathUtility.ProjectView(permission.project.id, 'assign')}
                  target="_blank"
                  size="xs"
                  c="dimmed">
                  → {rule.name ?? `Rule #${rule.ruleId}`}
                </Anchor>
              ))}
            </Group>
          )}
        </Group>
      ))}
    </>
  );
};
